var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineheart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.39 5.96C19.04 5.96 18.75 5.67 18.75 5.32C18.75 3.09 16.93 1.27 14.7 1.27C12.94 1.27 11.18 2.38 10.61 3.85H9.42C8.85 2.38 7.09 1.27 5.33 1.27C3.09 1.28 1.28 3.09 1.28 5.33C1.28 5.68 0.99 5.97 0.64 5.97C0.29 5.97 0 5.68 0 5.33C0 2.39 2.39 0 5.33 0C7.18 0 8.99 0.93 10.02 2.32C11.05 0.93 12.85 0 14.71 0C17.65 0 20.04 2.39 20.04 5.33C20.04 5.68 19.75 5.97 19.4 5.97L19.39 5.96Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.01 17.16L9.67 16.95C6.06 14.67 0 10.14 0 5.33C0 4.98 0.29 4.69 0.64 4.69C0.99 4.69 1.28 4.98 1.28 5.33C1.28 9.51 7.13 13.8 10.01 15.65C12.89 13.8 18.74 9.51 18.74 5.33C18.74 4.98 19.03 4.69 19.38 4.69C19.73 4.69 20.02 4.98 20.02 5.33C20.02 10.14 13.96 14.67 10.35 16.95L10.01 17.16Z",
    fill: "#828282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.02,
    height: 17.16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineheart);
export default __webpack_public_path__ + "static/media/lineheart.987dc4646a637637abbcbf00767045f2.svg";
export { ForwardRef as ReactComponent };